import { atom } from "jotai";
import { cursorAtom } from "./cursorAtom";
import { selectedNodeTypeAtom } from "./selectedNodeTypeAtom";
import { isMoreMenuOpenAtom } from "./isMoreMenuOpenAtom";
import { removeEphemeralEmbedNodesSetter } from "../nodes/removeEphemeralEmbedNodesSetter";

/**
 * Toggles the "more" menu visibility and resets related state.
 * - Clears any selected node type to ensure no conflicting selections
 * - Resets cursor to "select" mode to match other DiagrammingToolbar button behavior
 * - Removes any existing ephemeral embed nodes (only allow one at a time)
 */
export const toggleMoreMenuSetter = atom(null, (get, set) => {
  set(selectedNodeTypeAtom, null);
  set(cursorAtom, "select");

  // Remove existing ephemeral embed nodes when opening more menu
  const wasOpen = get(isMoreMenuOpenAtom);
  if (!wasOpen) {
    set(removeEphemeralEmbedNodesSetter);
  }

  set(isMoreMenuOpenAtom, (prev) => !prev);
});

toggleMoreMenuSetter.debugLabel = "toggleMoreMenuSetter";
